import { Stack, Typography, Link, Divider } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function ContactInfo() {
  const { t } = useTranslation();
  return (
    <Stack spacing={2} padding={6} textAlign="left" alignItems="center">
      <Typography variant="h3" textAlign="center" paddingBottom="1em">
        {t("contactInfo.title")}
      </Typography>
      <Stack width="80%" spacing={4} divider={<Divider />}>
        <Stack spacing={2}>
          <Typography>{t("contactInfo.webshop")}</Typography>
          <Link href={"https://pohde.zendesk.com/hc/fi-fi"}>
            <Typography>{t("footer.helpdesk")}</Typography>
          </Link>
        </Stack>
        <Stack spacing={2}>
          <Stack>
            <Typography>{t("contactInfo.name")}</Typography>
            <Typography fontWeight="bold">
              {t("contactInfo.noCustomerService")}
            </Typography>
          </Stack>
          <Typography>
            {t("contactInfo.email")}: {t("contactInfo.emailContent")}
          </Typography>
          <Typography>
            {t("contactInfo.businessId")}: {t("contactInfo.businessIdContent")}
          </Typography>
          <Typography>{t("contactInfo.postAddress")}</Typography>
          <Typography>{t("contactInfo.name")}</Typography>
          <Typography>{t("contactInfo.postAddressContent")}</Typography>
          <Typography>{t("contactInfo.city")}</Typography>
        </Stack>
      </Stack>
    </Stack>
  );
}
